package com.willandsons.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initLovenearbySafetyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("LovenearbySafety.md", FrontMatterElement.Builder { addScalar("title", "Safety Advice"); }))
}

@Page("/lovenearby-safety")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun LovenearbySafetyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("safety-advice") }) {
        org.jetbrains.compose.web.dom.Text("SAFETY ADVICE")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We know that meeting new people is exciting but you have to be very careful with the signals you receive from others. We want your experience on LoveNearby to be as enjoyable as possible, so we offer you a few suggestions to help you to be and to feel completely safe.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Below we give you some advice, but the decision is yours! Listen to your instincts, your best judgments, explore, communicate, and find what you are looking for!")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Online safety:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Protect your personal information")
                }
                org.jetbrains.compose.web.dom.Text(": Don't make the mistake of revealing personal information, such as your home address, work address, phone number, or other identifying information, in the early stages of online conversations. Only you are the one who decides when and if it's the right time to share part of your personal information. If someone insists on you giving them identification details, don't do it until you feel completely safe. Keep conversations on the LoveNearby platform while you’re getting to know someone. Often users with bad intentions try to move the conversation to text, messaging apps, email, or phone right away.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Never send money or share financial information: Do not give information about the source of your income. Avoid emphasizing the financial aspect in your discussions with other users, in order not to risk attracting people who are only interested in this aspect. Never send money, even if the person claims to be in an emergency. Never share information that could be used to access your financial accounts. If another user asks you for money, report it to us immediately.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Be wary of suspicious behavior: Be wary of anyone who will not meet in person or talk on a phone/video call—they may not be who they say they are. If someone is avoiding your questions or pushing for a serious relationship without meeting or getting to know you first, that’s a red flag.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Report any suspicious behavior to us: this way, those who abuse the trust of the APP users may be excluded from this community, which encourages quality relationships based on communication and mutual honesty. Some example of suspicious behavior:")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("Harassment, threats, and abusive messages")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("The user is sending spam")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("Requests for money or donations")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("The user offers to sell or buy something including links to commercial websites or attempts to sell products or services")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("Underage users")
                    }
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you have any concern, don’t hesitate to write to us at: ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:groszvilmos@willandsons.com") {
            org.jetbrains.compose.web.dom.Text("groszvilmos@willandsons.com")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Offline safety:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Stay informed: Make sure you know enough about the person you are about to meet, do this when you are fully convinced that it is worth moving to the next step. Don’t be afraid to ask questions to screen for any red flags or personal dealbreakers. You can also have a phone conversation before meeting; this will certainly reveal at least some of their conversational and social qualities.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Meet in public: ALWAYS meet in a populated, public place — never at your home, your date’s home, or any other private location. If your date pressures you to go to a private location, end the date.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Tell a friend or family what you're going to do: Never go to a first date of this kind without first informing a friend or a family member about your intentions and the meeting location. Call your friend at the beginning and end of the date, or ask them to call you at a predetermined time, to feel completely safe! Don’t hesitate to inform your date about this as well!")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Think about your transportation: How will you get to and from your date? Make sure you have the possibility to leave whenever you want.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Drinks and drugs: Be aware of the effects of drugs or alcohol on you specifically — they can impair your judgment and your alertness. If your date tries to pressure you to use drugs or drink more than you’re comfortable with, hold your ground and end the date. Be careful when it comes to drinks. If you leave the table, order another drink when you return to avoid contaminating it with harmful substances. Also regarding drinks, be moderate and choose non-alcoholic beverages, at least on the first date.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Keep your phone, purse, wallet on you all the times.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("If you feel uncomfortable, leave: It’s okay to end the date early if you’re feeling uncomfortable. And if your instincts are telling you something is off or you feel unsafe, ask the bartender or server for help.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Before you get physically intimate: All sexual activity must start with consent and should include ongoing check-ins with your partner. Verbal communication can help you and your partner ensure that you respect each other’s boundaries. Make sure you protect yourself from sexually transmitted diseases.")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Don't forget that only you know what is best for you! The choice is yours... maybe the person you met meets your expectations, or maybe the meeting wasn't exactly what you wanted. At future meetings, keep our advice in mind until you feel completely comfortable in the company of those people.")
    }
}
